import React, { useState } from 'react';
import SEOHead from '../components/SEOHead';
import { BreadcrumbSchema } from '../components/JsonLdSchema';
import { trackEvent } from '../lib/analytics';

function CallbackForm() {
  const [name, setName] = useState('');
  const [restaurant, setRestaurant] = useState('');
  const [phone, setPhone] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const lines = [
      'Hi DPOS Sales, I would like to book a free demo.',
      name && `Name: ${name}`,
      restaurant && `Restaurant: ${restaurant}`,
      phone && `Phone: ${phone}`,
    ].filter(Boolean);
    const url = `https://wa.me/919136843555?text=${encodeURIComponent(lines.join('\n'))}`;
    trackEvent('generate_lead', { source: 'contact_callback_form' });
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const inputStyle = {
    width: '100%', padding: '11px 14px', borderRadius: 8,
    border: '1px solid #e5e7eb', fontSize: 14, color: '#111827',
    boxSizing: 'border-box',
  };

  return (
    <form onSubmit={handleSubmit} style={{
      background: '#fff', border: '1px solid #e5e7eb', borderRadius: 16,
      padding: '32px 28px', display: 'flex', flexDirection: 'column', gap: 14,
    }}>
      <h2 style={{ fontSize: 20, fontWeight: 800, color: '#111827', marginBottom: 2 }}>Get a Call Back</h2>
      <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 6 }}>
        Leave your details and our team will reach out on WhatsApp — no need to type anything yourself.
      </p>
      <input type="text" placeholder="Your name" value={name} onChange={e => setName(e.target.value)} style={inputStyle} required />
      <input type="text" placeholder="Restaurant name" value={restaurant} onChange={e => setRestaurant(e.target.value)} style={inputStyle} />
      <input type="tel" placeholder="Phone number" value={phone} onChange={e => setPhone(e.target.value)} style={inputStyle} required />
      <button type="submit" style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
        background: '#CC0000', color: '#fff', border: 'none', cursor: 'pointer',
        padding: '12px 24px', borderRadius: 8, fontSize: 15, fontWeight: 700, marginTop: 4,
      }}>
        Book a Free Demo →
      </button>
    </form>
  );
}

export default function Contact() {
  return (
    <main style={{ paddingTop: 64 }}>
      <SEOHead
        title="Contact DPOS – Book a Free Restaurant POS Demo"
        description="Get in touch with DPOS for sales inquiries, technical support, or to book a free demo of our restaurant POS and billing solution."
        canonical="/contact"
      />
      <BreadcrumbSchema items={[
        { name: 'Home', path: '/' },
        { name: 'Contact' },
      ]} />
      <section style={{ padding: '72px 24px 80px' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto' }}>
          <h1 style={{ fontSize: 'clamp(32px, 4vw, 48px)', fontWeight: 800, color: '#111827', marginBottom: 12 }}>Contact Us</h1>
          <p style={{ fontSize: 16, color: '#6b7280', maxWidth: 560, lineHeight: 1.7, marginBottom: 40 }}>
            Let's grow your restaurant together. Reach out to our team for sales inquiries,
            technical support, or to book a free demo of our POS solution.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'start', marginBottom: 56 }} className="contact-grid">
            <CallbackForm />
            <div style={{ paddingTop: 8 }}>
              <h2 style={{ fontSize: 18, fontWeight: 800, color: '#111827', marginBottom: 20 }}>Why restaurants book a demo</h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
                {[
                  { icon: '★', text: '5.0 rated by restaurants on Google (8 reviews)' },
                  { icon: '🏬', text: 'Trusted by 100+ restaurants across India' },
                  { icon: '🔄', text: 'No migration charges to switch from your current system' },
                  { icon: '🕑', text: '24/7 support, with free setup included' },
                ].map(f => (
                  <div key={f.text} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                    <span style={{ fontSize: 18, color: '#CC0000', flexShrink: 0 }}>{f.icon}</span>
                    <span style={{ fontSize: 14, color: '#374151', lineHeight: 1.6 }}>{f.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'flex-start' }} className="contact-grid">
            <div>
              <h3 style={{ fontSize: 18, fontWeight: 700, color: '#111827', marginBottom: 6 }}>Our Headquarters</h3>
              <p style={{ fontSize: 12, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 16 }}>Main Office</p>
              <p style={{ fontSize: 14, color: '#374151', lineHeight: 1.7 }}>
                39, 1st Floor, Om Heera Panna Premises Co-Op. Soc. Ltd., Opp Cafe Safar Restaurant,<br />
                New link Road, Oshiwara, Mumbai, Maharashtra - 400102, India
              </p>
              <p style={{ fontSize: 12, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.08em', margin: '16px 0 8px' }}>Phone Numbers</p>
              <p style={{ fontSize: 14, color: '#374151' }}>Sales: <a href="tel:+919136843555" onClick={() => trackEvent('contact_click', { method: 'phone', source: 'sales' })} style={{ color: '#CC0000' }}>+91 91368 43555</a></p>
              <p style={{ fontSize: 14, color: '#374151' }}>Support: <a href="tel:+919920593222" onClick={() => trackEvent('contact_click', { method: 'phone', source: 'support' })} style={{ color: '#CC0000' }}>+91 99205 93222</a></p>
              <p style={{ fontSize: 12, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.08em', margin: '16px 0 8px' }}>Email Support</p>
              <p style={{ fontSize: 14 }}><a href="mailto:sales@dpos.co.in" onClick={() => trackEvent('contact_click', { method: 'email', source: 'sales' })} style={{ color: '#CC0000' }}>sales@dpos.co.in</a></p>
              <p style={{ fontSize: 14 }}><a href="mailto:support@dpos.co.in" onClick={() => trackEvent('contact_click', { method: 'email', source: 'support' })} style={{ color: '#CC0000' }}>support@dpos.co.in</a></p>
              <div style={{ marginTop: 8, display: 'inline-block', background: '#f3f4f6', borderRadius: 6, padding: '4px 10px', fontSize: 12, color: '#6b7280' }}>Mumbai</div>
            </div>

            <div style={{ background: '#f9fafb', borderRadius: 16, padding: 28 }}>
              <h3 style={{ fontSize: 18, fontWeight: 700, color: '#111827', marginBottom: 20 }}>Connect on WhatsApp</h3>
              <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 24 }}>Get instant replies from our dedicated teams.</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {[
                  {
                    label: 'WhatsApp Support', sub: 'For existing customers seeking assistance',
                    btnText: 'Chat with Support', btnHref: 'https://wa.me/919920593222?text=Hi%20DPOS%20Support%2C%20I%20need%20help%20with...',
                    badge: null, source: 'contact_whatsapp_support',
                  },
                  {
                    label: 'WhatsApp Sales', sub: 'Book a Free Demo for your restaurant',
                    btnText: 'Book a Free Demo', btnHref: 'https://wa.me/919136843555?text=Hi%20DPOS%20Sales%2C%20I%20want%20to%20book%20a%20free%20demo.',
                    badge: 'Fastest', source: 'contact_whatsapp_sales',
                  },
                ].map(w => (
                  <div key={w.label} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: '18px 20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                      <p style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>{w.label}</p>
                      {w.badge && <span style={{ fontSize: 10, fontWeight: 700, background: '#dcfce7', color: '#15803d', padding: '2px 8px', borderRadius: 100 }}>{w.badge}</span>}
                    </div>
                    <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 14 }}>{w.sub}</p>
                    <a href={w.btnHref} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('whatsapp_click', { source: w.source })} style={{
                      display: 'inline-flex', alignItems: 'center', gap: 6,
                      background: '#25d366', color: '#fff',
                      padding: '8px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600
                    }}>💬 {w.btnText}</a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`@media(max-width:768px){.contact-grid{grid-template-columns:1fr !important;}}`}</style>
    </main>
  );
}
